import { AuthMessageType, ClientType, ConnectionMessage, ConnectionMessageType, websocket } from '@playcastdotio/Messaging';
import { getStateStore } from '../../../stores';
import { getElectronStores } from '../../../stores/electronStores';
import { attachSentryTraceToMessage } from '../../realtime/tracing';

const electronStores = getElectronStores();

export const handleConnectionMessage = async (message: ConnectionMessage, rawSocket: WebSocket | null) => {
  console.log('Connection message:', message);
  const state = getStateStore('ipc');
  const accessToken = state.authState.currentState.accessToken;

  switch (message.type) {
    case ConnectionMessageType.CONN_AUTH_REQUIRED: {
      console.log('Auth required');
      const machineId = await new Promise<string>((resolve, reject) => {
        if (electronStores.machineIdState.currentState) {
          console.log('Using cached machine ID:', electronStores.machineIdState.currentState);
          resolve(electronStores.machineIdState.currentState);
        } else {
          console.log('Waiting for machine ID');
          const listener = electronStores.machineIdState.addListener((id) => {
            electronStores.machineIdState.removeListener(listener);
            console.log('Received machine ID:', id);
            resolve(id);
          });
        }
      });
      const msg = websocket.generators.auth(AuthMessageType.AUTH_REQUEST, {
        clientType: ClientType.REMOTE_HOST,
        tokenJwt: accessToken,
        machineId,
      });
      // Bypass ready check
      attachSentryTraceToMessage(msg);
      rawSocket?.send(JSON.stringify(msg));
    }
  }
};
